import React from 'react';
import ProductPage from '../components/product-page';

export default function PmpPage() {
  return (
    <ProductPage
      title="Panelboards with Smart Metering"
      className="smart-power-commercial"
      demoLink="http://benjaminelectric.com/pmi"
      images={[
        {
          src: 'pmp-cutout-view.png',
          alt: 'Diagram of panelboard showing control system',
        },
        {
          src: 'pmi-overview.png',
          alt: 'Sample image of web interface for smart metering',
        },
        {
          src: 'pmi-monthly-energy.png',
          alt: 'Sampmle image of bar graphs for Monthly Energy Use',
        },
        {
          src: 'pmi-timers.png',
          alt: 'Scheduling for controlling breakers',
        },
      ]}
      sections={[
        {
          title: 'Description',
          id: 'description',
          content: (
            <>
              An efficient addition to your Lighting Controls and Energy
              Management Systems. The Benjamin Smart Panel features
              circuit-level power metering and remote controllable breakers to
              help you save energy.
            </>
          ),
        },
        {
          title: 'Features',
          id: 'features',
          content: (
            <ul>
              <li>
                Power Metering on all branch circuits and mains with local data
                logging that provides easy identification of areas with high
                energy use.
              </li>
              <li>
                Available with remote switchable branch breakers which can be
                controlled through scheduling, events, or local I/O.
              </li>
              <li>
                Access metering data remotely using standard web browsers, no
                software install or license fees.
              </li>
              <li>
                Industry Standard communication protocols are supported for
                integration with Building Management Systems.
              </li>
              <li>
                Built to order, customized to your specifications, including
                retrofit upgrades to existing enclosures.
              </li>
              <li>
                Compliance with
                <strong>
                  {' '}
                  ASHRAE 90.1-2013, 8.4.3 Electrical Energy Monitoring{' '}
                </strong>
                requires aggregating loads of HVAC, exterior lighting, interior
                lighting, and receptacles separately. Existing solutions
                physically segregate the loads into separate sections and end up
                taking up more space. With circuit level metering these loads
                can be aggregated through software regardless of where they’re
                physically located.
              </li>
            </ul>
          ),
        },
        {
          title: 'Specifications',
          id: 'specifications',
          content: (
            <>
              <table>
                <tbody>
                  <tr>
                    <th>Voltage Ratings</th>
                    <td>120/240V 1Ø 3W</td>
                    <td>208Y/120V 3Ø 4W</td>
                    <td>480Y/277V 3Ø 4W</td>
                  </tr>
                </tbody>
              </table>
              <table id="aic_ratings">
                <tbody>
                  <tr>
                    <th rowSpan="2">AIC Ratings</th>
                    <td className="left-align">
                      65kAIC@240V Fully Rated to 100kAIC Series Rated
                    </td>
                  </tr>
                  <tr>
                    <td className="left-align">
                      14kAIC@480Y/277V Fully Rated to 65kAIC Series Rated
                    </td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>

              <table id="breaker_options">
                <tbody>
                  <tr>
                    <th rowSpan="3">Branch Circuit Breaker Options</th>
                    <td>1 Pole</td>
                    <td className="left-align">
                      Ratings: 15A, 20A, 30A Controlled, 15A to 100A
                      non-controlled
                    </td>
                  </tr>
                  <tr>
                    <td>2 Pole</td>
                    <td className="left-align">
                      Ratings: 15A, 20A, 30A Controlled, 15A to 100A
                      non-controlled
                    </td>
                  </tr>
                  <tr>
                    <td>3 Pole</td>
                    <td className="left-align">
                      Ratings: 15A to 100A non-controlled
                    </td>
                  </tr>
                </tbody>
              </table>

              <table id="main_options">
                <tbody>
                  <tr>
                    <th rowSpan="2">Mains Configurations</th>
                    <td>Lugs</td>
                    <td className="left-align">
                      Ratings: 100A, 225A, 400A, and 600A Rated
                    </td>
                  </tr>
                  <tr>
                    <td>Breaker</td>
                    <td className="left-align">
                      Ratings: 100A, 225A, 400A, and 600A Rated
                    </td>
                  </tr>
                </tbody>
              </table>

              <table id="breaker_options">
                <tbody>
                  <tr>
                    <th rowSpan="6">Power Measurement</th>
                    <td>Mains Current Accuracy</td>
                    <td className="left-align">
                      1% of reading from 1% to 100% of nominal rated current
                    </td>
                  </tr>
                  <tr>
                    <td>Mains Voltage Accuracy</td>
                    <td className="left-align">
                      0.5% of reading from 90 to 600 VAC Line to Neutral
                    </td>
                  </tr>
                  <tr>
                    <td>Mains Power Data</td>
                    <td className="left-align">
                      Voltage, Current, Watts, PF, VA, VAR, HZ, WHrs, VAHrs,
                      VARHrs
                    </td>
                  </tr>
                  <tr>
                    <td>Branch Current Accuracy</td>
                    <td className="left-align">
                      1% of reading from 0.15 Amps to 100 Amps
                    </td>
                  </tr>
                  <tr>
                    <td>Branch Circuit Data</td>
                    <td className="left-align">
                      Current, Watts, PF, VA, VAR, WattHrs, VAHrs, VARHrs
                    </td>
                  </tr>
                  <tr>
                    <td>Data Update Rate</td>
                    <td className="left-align">
                      1 second for all real-time values
                    </td>
                  </tr>
                </tbody>
              </table>

              <table id="communications">
                <tbody>
                  <tr>
                    <th>Communications</th>
                    <td className="left-align">
                      DMX-512, Modbus 485, Modbus TCP/IP, Bacnet IP, Web Server
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          ),
        },
        {
          title: 'Downloads',
          id: 'downloads',
          content: (
            <ul style={{ listStyle: 'none' }}>
              <li>
                <a href="/downloads/brochure-power-metered-panelboard.pdf">
                  Product Brochure
                </a>
              </li>
            </ul>
          ),
        },
      ]}
    />
  );
}
